import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';

import { AuthenticationService } from '../authentication/auth.service';

export const httpTokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const authenticationService: AuthenticationService = inject(
    AuthenticationService
  );
  if (req.headers.get('skip')) return next(req);
  const headersConfig = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: '',
  };

  const token = authenticationService.getToken();
  if (token) {
    headersConfig['Authorization'] = `Bearer ${token}`;
  }

  const request = req.clone({ setHeaders: headersConfig });
  return next(request);
};
